import { CopyClick } from '@/components/shared/copy-click';
import { useTranslation } from 'react-i18next';
import AirdropTask from './AirdropTask.component';
import {
  useTaskControllerFindAmpTasksByFiltersQuery,
  useTaskControllerFindCompletedAmpTasksByFiltersQuery,
} from '@/store/services/MidleNestApi.service';
import { Avatar } from '@/components';
import { useProfile } from '@/hooks';

export function AirdropHome() {
  const { t } = useTranslation();

  const { profile } = useProfile();

  const { data: tasks } = useTaskControllerFindAmpTasksByFiltersQuery({ page: 1, limit: 10 });
  const { data: completedTasks } = useTaskControllerFindCompletedAmpTasksByFiltersQuery({});

  return (
    <div className='text-white pb-14 px-3 lg:px-0 font-clash-display'>
      <div className='relative w-full overflow-hidden flex flex-col items-center py-16 border-b border-[#FFDA68] mb-11'>
        <img
          className='absolute -left-40 -top-60 w-[40vw] max-w-lg opacity-10'
          src='/midle-parachute.png'
        />
        <img
          className='absolute -right-40 -top-20 rotate-[30deg] w-[40vw] max-w-lg opacity-10'
          src='/midle-parachute.png'
        />
        <Avatar
          className='lg:w-44 lg:h-44 w-28 h-28 rounded-full border border-[#FFDA68] sm:!text-4xl lg:!text-5xl'
          name={profile.user.username || ''}
          src={profile?.avatar?.src}
        />

        <div className='text-[26px] font-bold mt-7 truncate w-full text-center'>
          {profile.user.username}
        </div>
        <div
          style={{
            background:
              'linear-gradient(135deg, transparent 20px, #FFDA68 calc(5% - 24px), #FFDA68 95%, transparent 10px)',
          }}
          className='flex flex-col lg:flex-row items-center mt-9 px-12 py-4 lg:px-7 lg:py-2.5 text-[#151515] max-w-full'
        >
          <div className='text-center w-full font-medium lg:hidden border-b-2 pb-2 border-[#151515]'>
            <div className='text-5xl font-bold'>{profile.currentAmp ?? 0}</div>
            <div className='text-sm'>{t('MXP')}</div>
          </div>

          <div className='flex lg:items-center space-x-11 mt-2 lg:mt-0'>
            <div className='flex lg:items-center flex-col lg:flex-row'>
              <div className='text-center font-medium'>
                <div className='text-sm'>{t('Total Referrals')}</div>
                <div className='text-2xl'>{profile.referredByCount}</div>
              </div>

              <div className='text-center lg:ml-11 font-medium hidden lg:block'>
                <div className='text-5xl font-bold'>{profile.currentAmp ?? 0}</div>
                <div className='text-sm'>{t('MXP')}</div>
              </div>
            </div>

            <div className='text-center font-medium'>
              <div className='text-sm'>{t('Referral Code')}</div>
              <CopyClick prefix='' className='bg-transparent'>
                {`https://app.midle.io/register?ref=${profile.id}`}
              </CopyClick>
            </div>
          </div>
        </div>
      </div>

      <div className='font-semibold text-4xl text-[#FFDA68] text-center'>{t('TASKS')}</div>

      <div
        style={{
          background:
            'linear-gradient(135deg, transparent 1.5%, #FFDA68 calc(1%), #FFDA68 98.5%, transparent 5px)',
        }}
        className='w-full max-w-5xl p-[1px] mx-auto mt-6'
      >
        <div
          style={{
            background:
              'linear-gradient(135deg, transparent 1.5%, #242424 calc(1%), #242424 98.5%, transparent 5px)',
          }}
          className='w-full h-full px-8 py-9 space-y-2.5'
        >
          {tasks?.list.map((task) => (
            <AirdropTask task={task} key={task.id} />
          ))}
        </div>
      </div>

      {!!completedTasks?.list.length && (
        <>
          <div className='font-semibold text-4xl text-[#FFDA68] text-center mt-12'>
            {t('COMPLETED')}
          </div>

          <div
            style={{
              background:
                'linear-gradient(135deg, transparent 1.5%, #FFDA68 calc(1%), #FFDA68 98.5%, transparent 5px)',
            }}
            className='w-full max-w-5xl p-[1px] mx-auto mt-6 opacity-20 pointer-events-none'
          >
            <div
              style={{
                background:
                  'linear-gradient(135deg, transparent 1.5%, #242424 calc(1%), #242424 98.5%, transparent 5px)',
              }}
              className='w-full h-full px-8 py-9 space-y-2.5'
            >
              {completedTasks?.list.map((task) => (
                <AirdropTask task={task} key={task.id} completed />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
